<template>
    <div>
      <div class="content-header case-search-header case_reports_header generate_invoice">
        <div class="content-header-left" >
          <!-- <div class="search">
            <vs-input icon-pack="feather" icon="icon-search"
              :placeholder="beneficiaryId ==null?'Search by Case No/Beneficiary':'Search by Case No'"
              class="is-label-placeholder" v-model.lazy="searchtxt" />
  
          </div> -->
          <template v-if="true">
            <div class="search">
            <vs-input icon-pack="feather" icon="icon-search"
              :placeholder="'Search by Case No/Beneficiary/Petitioner'"
              class="is-label-placeholder" v-model.lazy="searchtxt" />
  
          </div>
              <div class="con-select selection_search petitioners case_reports_multiselect" v-if="allowLawOfficeUser">
                <label class="select_label">Petitioner</label>
                <multiselect  v-model="selectedPetitioners" :options="petitionersList" @input="updateLoader()"
                  :multiple="true" :hideSelected="true" :close-on-select="false" :clear-on-select="false"
                  :preserve-search="true" placeholder="Select Petitioner" label="name" track-by="name"
                  :preselect-first="false" @search-change="peritioners_search_fun">
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                      Petitioner(s) Selected</span>
                    <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                  </template>
                </multiselect>
              </div>
              <div class="con-select selection_search petitioners case_reports_multiselect create_date">
                <label class="select_label">Created Date</label>
                <date-range-picker  :maxDate="new Date()" :autoApply="autoApply" :showDropdowns="true" :showCalendars="true"
                  :opens="'right'" v-model="selected_createdDateRange"></date-range-picker>
                <span class="date_clear" v-if="checkCreatedVal"  @click="clearDateRangePicker()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><defs></defs><path class="a" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.3,12.708L12.705,14.3A36.72,36.72,0,0,0,10,11.6a37.242,37.242,0,0,0-2.706,2.7L5.7,12.708A31.208,31.208,0,0,0,8.4,10,30.784,30.784,0,0,0,5.7,7.3L7.292,5.7s2.541,2.7,2.706,2.7,2.708-2.7,2.708-2.7L14.3,7.3A36.62,36.62,0,0,0,11.591,10C11.591,10.183,14.3,12.708,14.3,12.708Z" fill="#9eacc1" /></svg>
                </span>
              </div>
              <div class="con-select selection_search petitioners case_reports_multiselect">
                <label class="select_label">Case Type</label>
                <multiselect @input="changedPetitionVisaType();updateLoader()" v-model="selectedPetitionType" :options="petitionTypes"
                  :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true"
                  placeholder="Select Case Type" label="name" track-by="name" :preselect-first="false">
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }} Case
                      Type(s) Selected</span>
                    <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                  </template>
                </multiselect>
              </div>

              <!---all_subtypes---->
              <div class="con-select selection_search petitioners case_reports_multiselect">
                <label class="select_label">Case Subtype</label>
                <multiselect v-model="selectedPetitionSubType" :options="petitionSubTypes"
                :disabled="selectedPetitionType==null" @input="updateLoader()"
                  :multiple="true" :hideSelected="true" :close-on-select="false"
                  :clear-on-select="false" :preserve-search="true" placeholder="Select Case Subtype" label="name"
                  track-by="name" :preselect-first="false">

                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }} Case
                      Subtype(s) Selected</span>
                    <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                  </template>
                </multiselect>
              </div>
              <div class="con-select selection_search petitioners case_reports_multiselect"
                v-if="allowLawOfficeUser">
                <label class="select_label">Assigned Attorney</label>
                <multiselect  v-model="selected_users" :options="assigneeList" @input="updateLoader()"
                  :multiple="true" :hideSelected="true" :close-on-select="false" :clear-on-select="false"
                  :preserve-search="true" placeholder="Select Attorney" label="name" track-by="_id"
                  :preselect-first="false" @search-change="usersAttorneySearch">
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                      Attorney(s) Selected</span>
                    <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                  </template>

                </multiselect>

              </div>
              <span class="view_rpt_btn cursor" :class="{'btn_disabled':filterApplyed || !checkFilterAppliedval}" @click="filterApplyed=true;set_filter()"> 
                <span v-if="filterApplyed" class="loader"><img src="@/assets/images/main/loader.gif"></span>
                  Search 
              </span> 
          
        </template>
        <!-- <vs-button color="primary" type="border" class="light-blue-btn nowrap"
                @click="resetConfiramtionPopup = true"  v-if="getselectedForInvoicesList">Reset <span>
                <img class="add-user-icon ml-2" src="@/assets/images/main/add-user.svg">
              </span></vs-button>

              <vs-button color="primary" type="border" class="light-blue-btn nowrap"
              @click="generateBulkInvoices()"
              v-if="getselectedForInvoicesList">

              Create Invoice <span>
                <img class="add-user-icon ml-2" src="@/assets/images/main/add-user.svg">
              </span></vs-button> -->
              <div class="header_action_btns">
                <span class="view_rpt_btn reset_btn" v-if="getselectedForInvoicesList && checkFilterAppliedval" @click="resetConfiramtionPopup = true; bulkCreateLoader= false" > 
                  Reset 
                </span>
                <span class="view_rpt_btn cursor" v-if="getselectedForInvoicesList && checkFilterAppliedval" @click="generateBulkInvoices()" > 
                  <span v-if="bulkCreateLoader" class="loader"><img src="@/assets/images/main/loader.gif"></span>
                  Create Invoice 
                </span>
              </div>
        </div>
        
      </div>
      <!-- noDataText resetInvoices() :checkLocading="false" -->
      <NoDataFound ref="NoDataFoundRefff" :loading="false" v-if="pendingInvoiceList.length == 0 || !checkFilterAppliedval" content=""
        :heading="(checkFilterAppliedval  && !clearedFromComputed) && callFromList? 'No Results Found' : 'Search by Case No/Beneficiary/Petitioner'"
         type='petitions' />
      <div class="accordian-table custom-table custom-tableV2 index9" v-if="pendingInvoiceList.length > 0 && checkFilterAppliedval">
        
        <div class="vs-table--content">
          <div class="vs-con-tbody">
            <table class="vs-table vs-table--tbody-table">
              <thead class="vs-table--thead">
                <tr>
                  <th>
  
                    <div class="vs-table-text d-flex align-center">
                      <vs-checkbox :disabled="!enableSelectedAll"
                      @change="selectAllforInvoices()" :name="'selecteAll'" v-model="selectAllInvoices"
                      ></vs-checkbox>
                      <a @click="sortMe('beneficiaryCustomId')"
                        v-bind:class="{ 'sort_ascending': sortKeys['beneficiaryCustomId'] == 1, 'sort_descending': sortKeys['beneficiaryCustomId'] != 1 }">Case No
                      </a>
                    </div>
                  </th>
                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('beneficiaryName')"
                        v-bind:class="{ 'sort_ascending': sortKeys['beneficiaryName'] == 1, 'sort_descending': sortKeys['beneficiaryName'] != 1 }">Beneficiary</a>
                    </div>
                  </th>
                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('petitionType')"
                        v-bind:class="{ 'sort_ascending': sortKeys['petitionType'] == 1, 'sort_descending': sortKeys['petitionType'] != 1 }">Case Type</a>
                    </div>
                  </th>
                  <th>
                    <div class="vs-table-text">
                      Filing Fee
                     
                    </div>
                  </th>
                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('issuedToDetails')"
                        v-bind:class="{ 'sort_ascending': sortKeys['issuedToDetails'] == 1, 'sort_descending': sortKeys['issuedToDetails'] != 1 }">Issued To</a>
                    </div>
                  </th>
                  
                  
                  
                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('invoiceRaiseDate')"
                        v-bind:class="{ 'sort_ascending': sortKeys['invoiceRaiseDate'] == 1, 'sort_descending': sortKeys['invoiceRaiseDate'] != 1 }">Pending Since</a>
                    </div>
                  </th>
                  <th class="actions">Documents</th>
                </tr>
              </thead>
              <tr class="vs-table--tr" v-for="(petition, index) in pendingInvoiceList" :key="index"> 
                <td class="td vs-table--td">
                  <span>
                    <div class="d-flex align-center">
                      <vs-checkbox @change="selectForInvoice(petition)" :disabled="!getSelectedObj({'obj':petition})" :name="'selected_' +index" v-model="petition.isInvoiceSelected"></vs-checkbox>
                      
                      <div class="cursor-pointer" @click="showDetails(petition)"> {{ petition.beneficiaryCustomId }} </div>
                    </div>
                  </span>
                </td>
                  <td class="td_label">
                  <span :title="checkProperty(petition, 'beneficiaryName')" class="wrd-substr" >{{
                    checkProperty(petition, 'beneficiaryName')
                  }}</span>
                  <span >
                    <small> {{ checkProperty(petition ,'beneficiaryEmail') }} </small>
                  </span>
                </td>
                <td class="td_label" >
                  <div >
                    {{ checkProperty(petition, 'petitionType') }} <br />
                    <small> {{ checkProperty(petition, 'subTypeName') }} </small>
                  </div>
                </td>
                <td class="td vs-table--td">
                  
                    
                  <div class="slected_items">
                    <ul>
                      <template v-for="(invoice, ind) in checkProperty(petition, 'feeDetails')">
                        <template v-if="checkProperty(invoice, 'isSelected') && !checkProperty(invoice, 'isAlreadyExist') ">
                          <li>
                            <label>
                              {{checkProperty(invoice, 'name')}}
                              <strong v-if="checkProperty(invoice, 'isEdit') == false">${{checkProperty(invoice, 'amount')}}</strong>
                              <span v-if="checkProperty(invoice, 'isEdit')">
                                <input :maxLength="6"
                                oninput="this.value = this.value.replace(/[^0-9 .]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');" v-model="invoice.amount" />
                              </span>
                              <!-- <input value="25" type="text" /> -->
                            </label>       
                            <div class="list-actions" @click="updateList()" > 
                              <span v-if="checkProperty(invoice, 'isEdit') == false"  @click="petition['feeDetails'][ind]['isEdit']=true;invoice['isEdit'] = true">
                                <img src="@/assets/images/icons/edit_icon.svg"  width="16" height="16"/>                                                                                     
                              </span>
                              <span v-if="checkProperty(invoice, 'isEdit') == true" @click="petition['feeDetails'][ind]['isEdit']=false;invoice['isEdit'] = false">
                                <svg  width="14" height="14" viewBox="0 0 12 12">
                                  <path id="Path_626" data-name="Path 626" d="M6,0a6,6,0,1,0,6,6A6.023,6.023,0,0,0,6,0ZM5.274,8.729,2.646,6.1l.994-.994L5.32,6.787,8.691,3.722l.946,1.04Z" fill="#97d856"/>
                                </svg>                                                          
                              </span>
                              <!-- v-if="checkProperty(invoice, 'isEdit') == true" -->
                              <em @click="petition['feeDetails'][ind]['isEdit']=false;invoice['isEdit'] = false;invoice['isSelected'] = false;checkSelectedVal(petition, index)">x
                                <!-- <img @click="petition['feeDetails'][ind]['isEdit']=false;invoice['isEdit'] = false;invoice['isSelected'] = false" src="@/assets/images/icons/delete_icon.svg"  width="16" height="16"/>                              -->
                              </em>
                            </div>              
                        </li>
                        </template>
                        
                      </template>
                      <li class="dropdown-list">
                        <vs-dropdown ref="addLabelDropdown" vs-custom-content vs-trigger-click class="cursor-pointer menu__label IB_tooltip" >  
                          <span>+</span>
                          <div class="tooltip_cnt w-auto nowrap"><p>Add Fee</p></div>
                      <vs-dropdown-menu color="#fff" class="vx-navbar-dropdown   profileDropdown profileDropdownv2 add_lebel_drpdwn"  >
                        <h6 class="sub-title padtl10">Select Applicable Fees</h6>
                          <VuePerfectScrollbar
                              ref="mainSidebarPss"
                              class="scroll-area--main-sidebar"
                              :settings="settings"
                              @ps-scroll-y="scroll"
                            >
                          <ul>
                            <template v-for="(invoice, ind) in checkProperty(petition, 'feeDetails')">
                              <li v-if="!checkProperty(invoice, 'isAlreadyExist')"> 
                                <vs-checkbox @change="checkSelectedVal(petition, index)" v-model="invoice.isSelected">{{checkProperty(invoice, 'name')}}
                                  <span v-if="checkProperty(invoice, 'online')" class="online_label">Online</span>
                                </vs-checkbox>
                              </li>
                            </template>
                          
                          </ul>
                          </VuePerfectScrollbar> 
                          <div class="btn_wrap">
                              <vs-button color="success" :disabled="loadingLabel" @click="openFilingFeePopup(petition, index)" class="save" type="filled"><img src="@/assets/images/main/create_label.svg"> Create New</vs-button>
                          </div>
                      </vs-dropdown-menu>
                      </vs-dropdown>
                      </li>
                    </ul>
                  </div>
                  <div class="custom__menu">
                    
                 </div>
                </td>
                <td class="td_label">
                  <div >
                    {{checkProperty(petition, 'issuedToDetails')}}
                 
                    </div>
                 
                </td>
                <td class="td vs-table--td"> 
                  <!-- <template v-if="checkProperty(petition, 'invoiceIds') && checkProperty(petition['invoiceIds'], 'length')==0">N/A</template>                   -->
                  <template v-if="checkProperty(petition, 'invoiceRaiseDate')=='N/A'">N/A</template>
                  <template v-else-if="checkProperty(petition, 'invoiceRaiseDate') || checkProperty(petition, 'invoiceRaiseDate') == 0">{{checkProperty(petition, 'invoiceRaiseDate')}} day(s) </template>
                  <template v-else> - </template>
                </td> 
                <!-- checkProperty(petition, 'filingFeeDocs', 'cheques') -->
                <td class="td vs-table--td">
                  <template v-if="checkProperty(petition, 'filingFeeDocs', 'cheques') && checkProperty(petition['filingFeeDocs'], 'cheques', 'length') > 0"> 
                    <ul class="documents_new_list single_doc">
                      <li class="doc_list_item"
                          v-if="checkProperty(petition, 'filingFeeDocs', 'cheques') && checkProperty(petition['filingFeeDocs'], 'cheques', 'length') > 0">
                          <documentsView @download_or_view="download_or_view" :type="'cheques'" :showTitle="false"
                              :documentsList="checkProperty(petition, 'filingFeeDocs', 'cheques')" :petitionDetails="petition" />
                              <span class="remove"><svg class="binicon" @click="petition['filingFeeDocs']['cheques'] = [];updateList()" width="12.9" height="17.688" viewBox="0 0 12.9 17.688"><defs></defs><g transform="translate(-121.874)"><path class="a" d="M176.415,245.215a.393.393,0,0,0,.393.393h9.972a.393.393,0,0,0,.393-.393V232.487H176.415v12.728ZM184,234.653h1.473v8.564H184Zm-2.946,0h1.473v8.564h-1.473Zm-2.946,0h1.473v8.564h-1.473Z" transform="translate(-53.47 -227.921)"/><path class="a" d="M131.635,1.805V.393A.393.393,0,0,0,131.242,0h-5.837a.393.393,0,0,0-.393.393V2.3h-2.746a.393.393,0,0,0-.393.393v.993a.393.393,0,0,0,.393.393h12.114a.393.393,0,0,0,.393-.393V2.689a.393.393,0,0,0-.393-.393h-2.746V1.805Zm-1.473.41h-3.676V1.473h3.676v.742Z"/></g></svg></span>
                      </li>
                      

                    </ul>
                  </template>
                  <button v-else class="IB_primary-btn sm" @click="uploadDocuments(petition, index)">Upload</button>
                  
                    
                </td> 
              </tr>
            </table>
          </div>
        </div>
        <div class="table_footer">
          <div class="vx-col  con-select pages_select" v-if="pendingInvoiceList.length > 0">
            <label class="typo__label">Per Page</label>
            <multiselect @input="changeperPage()" v-model="perpage" :options="perPeges" :multiple="false" :allow-empty="false"
              :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Per Page"
              :preselect-first="true">
  
            </multiselect>
            <span class="totla_list_count" v-if="totalCount"> Total <em>{{totalCount}}</em></span>
          </div>
          <paginate v-if="pendingInvoiceList.length > 0" v-model="page" :page-count="totalpages" :page-range="3"
            :margin-pages="2" :click-handler="pageNate"
            prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
            next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" :prev-text="'<i></i>'"
            :next-text="'<i></i>'" :container-class="'pagination vs-pagination--nav'" :page-class="'page-item'">
          </paginate>
        </div>
      </div>

      <vs-popup
      class="document_modal document_modal-v2 "
      :class="{ 'expand': expandModal, 'custom_close_doc_modal':showCloseIcon }"
      :title="checkProperty(selectedFile, 'name')"
      :active.sync="docPrivew"
    >
    <div class="document_actions" @click="expandModal = !expandModal">
      <figure v-if="!expandModal" class="maximize-img"><img src="@/assets/images/maximize.png"  width="18" height="18"/></figure>
      <figure v-else class="minimize-img"><img src="@/assets/images/minimize.png"  width="20" height="20"/></figure>
    </div>
    <div class="custom_close" v-if="showCloseIcon">
      <figure class="close_icon" @click="showConfrmLetterPopup = true;updateletterLoading = false;errorMessage=''">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 20 20"><path class="a" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.3,12.708L12.705,14.3A36.72,36.72,0,0,0,10,11.6a37.242,37.242,0,0,0-2.706,2.7L5.7,12.708A31.208,31.208,0,0,0,8.4,10,30.784,30.784,0,0,0,5.7,7.3L7.292,5.7s2.541,2.7,2.706,2.7,2.708-2.7,2.708-2.7L14.3,7.3A36.62,36.62,0,0,0,11.591,10C11.591,10.183,14.3,12.708,14.3,12.708Z"/></svg>
      </figure>
    </div>
      <h2>
        <img
          :class="{
            pdf_view_download: docType == 'pdf',
            office_view_download: docType == 'office',
            image_view_download: docType == 'image',
          }"
          class="download-button"
          @click="downloads3file(selectedFile)"
          src="@/assets/images/download.svg"
        />
      </h2>
      <div class="pdf_loader">
        <figure v-if="formSubmited && !saveEditedFile" class="loader loader2">
          <img src="@/assets/images/main/loader.gif" />
        </figure>

        <!-- <span :class="{'pdf_view_close':docType == 'pdf', 'office_view_close':docType == 'office'  , 'image_view_close 33':docType =='image'}" class="close close2" @click="docPrivew= false"></span> -->
        <template v-if="docType == 'office'">
          <div style="height: 90vh">
            <div id="placeholder" style="height: 100%"></div>
          </div>
        </template>
        <template v-else-if="docType == 'image'">
          <img :src="docValue" />
        </template>
        <template v-else-if="docType == 'pdf'">
          <div class="pdf" style="height: 90vh">
            <iframe
              v-if="docValue != ''"
              border="0"
              style="border: 0px"
              :src="docValue"
              height="100%"
              width="100%"
            >
            </iframe>
          </div>
        </template>
      </div>
    </vs-popup>
    <vs-popup class="holamundo main-popup cls-btn" title="Upload Documents" v-if="showUploadDocs" :active.sync="showUploadDocs">
            <div class="form-container"> 
              <!-- <fileUploadNote :fileNote="true" /> -->
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="form_group mb-5">
                    <label class="form_label">Cheques</label>
                    <div class="vs-component relative mb-0">                  
                      <file-upload
                        :multiple="false"
                        :hideSelected="true"
                        v-model="documents"
                        class="file-upload-input file_upload justify-center"
                        name="documentsUpload"
                        :accept="allDocEntity"
                        :emitCategory="selectedIndex"
                        @updateData="updateData"
                      >Upload
                      </file-upload>  
                    </div>
                    <!-- v-if="checkProperty(selectedPetition, 'filingFeeDocs', 'cheques') && checkProperty(selectedPetition['filingFeeDocs'], 'cheques', 'length') > 0" -->
                    <ul class="uploaded-list note_uploads mt-2" v-if="documents && documents.length>0" >
                      <template v-for="(file, fileindex) in documents">
                        <vs-chip
                          type="button"
                          @click="removeFiles(fileindex)"
                          :key="fileindex"
                          v-if="file.status !== false"
                          closable
                          >{{ file.name }}
                        </vs-chip>
                      </template>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="popup-footer relative">
              <vs-button color="dark" class="cancel" type="filled" @click="hideUploadDocs(true)">Cancel</vs-button>
              <vs-button color="success" :disabled="documents.length<=0" class="save" type="filled" @click="hideUploadDocs()">Submit</vs-button>
            </div>
        </vs-popup>
        <vs-popup class="holamundo main-popup cls-btn" title="Reset Confirmation" v-if="resetConfiramtionPopup" :active.sync="resetConfiramtionPopup">
            <div class="form-container"> 
              <div class="vx-row">
                <div class="vx-col w-full">
                      <p style="line-height: 20px">
                          By performing this action unsaved changes will be reset.
                      </p>
                  </div>
              </div>
            </div>
            <div class="popup-footer relative">
              <vs-button color="dark" class="cancel" type="filled" @click="hideConfirmation(false)">Cancel</vs-button>
              <vs-button color="success"  class="save" type="filled" @click="hideConfirmation(true)">Reset</vs-button>
            </div>
        </vs-popup>
        <modal 
     
     name="createFilingFeeModal" 
     classes="v-modal-sec createFilingFeeModal"
     :min-width="200"
     :min-height="200"
     :scrollable="true"
     :reset="true"
     width="500px"
     height="auto">
   <div class="v-modal">
      
       <div class="popup-header fromDetailsPage">
         <h2 class="popup-title">Add Filing Fee</h2>
         <span @click="createFees(false);$modal.hide('createFilingFeeModal')">
           <em class="material-icons">close</em>
         </span>
       </div>
       <form @submit.prevent data-vv-scope="newLabelform" >
       <div class="form-container">
        <div class="vx-row">
           <div class="vx-col w-1/2">
             <div class="form_group">
               <label class="form_label">Fee Type<em>*</em></label>
               <vs-input :key="'name'" name="name" v-validate="'required'" class="w-full" data-vv-as="Fee Type" v-model="newFee.name" />
               <span  class="text-danger text-sm" v-show="errors.has('newLabelform.name')" >{{ errors.first("newLabelform.name") }}</span >
             </div>
           </div>
           <div class="vx-col w-1/2">
             <div class="form_group">
               <label class="form_label">Amount<em>*</em></label>
               <vs-input :maxLength="6" :key="'amount'" name="amount" oninput="this.value = this.value.replace(/[^0-9 .]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                 v-validate="'required'" class="w-full" data-vv-as="Amount" v-model="newFee.amount" />
               <span  class="text-danger text-sm" v-show="errors.has('newLabelform.amount')" >{{ errors.first("newLabelform.amount") }}</span >
             </div>
           </div>
        </div>



       </div>
       <div class="popup-footer relative" style="padding: 0 25px 0 !important;">
        <span class="loader" v-if="loadingLabel" ><img src="@/assets/images/main/loader.gif" /></span>
        <!-- <vs-button color="dark" @click="$modal.hide('createFilingFeeModal')" class="cancel" type="filled">Cancel
        </vs-button> -->
        <vs-button color="dark" @click="createFees(false)" class="cancel" type="filled">Cancel
        </vs-button>
        <vs-button color="success" :disabled="loadingLabel" @click="createFees(true)"  class="save m-0" type="filled">Submit</vs-button>
       </div>
     </form>
       
   
   </div>
    </modal>  
    <markAsCompleteInvoice v-if="markCompleteModal"
    :invoicesList="selectedInvoiceItems"
    @hideMe="hideMe" 
    :invoiceRespose="invoiceRespose"
     />
  
  
    </div>
  </template>
  <script>
  import { XIcon, MoreVerticalIcon } from 'vue-feather-icons'
  import immiPhone from "@/views/forms/fields/phonenumber.vue";
  import markAsCompleteInvoice from "@/views/invoice/markAsCompleteInvoice.vue";
 
  const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});
  import immiInput from "@/views/forms/fields/simpleinput.vue";
  import Paginate from "vuejs-paginate";
  import moment from 'moment'
  import _ from "lodash";
  import Vue from 'vue'
  import NoDataFound from "@/views/common/noData.vue";
  import Multiselect from "vue-multiselect-inv";
  import JQuery from "jquery";
  import addBenewPet from "@/views/common/invitePet.vue"
  import addBeneficiary from "@/views/common/addBeneficiary.vue"
  //import addBeneficiary  from "@/views/common/addBeneficiary.vue" 
  //import addPetitioner  from "@/views/common/addPetitioner.vue" 
  import DateRangePicker from "vue2-daterange-picker";
  import Datepicker from "vuejs-datepicker-inv";
  import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import FileUpload from "@/views/FileUpload.vue";
  //import JsonExcel from "vue-json-excel";
  //Vue.component("downloadExcel", JsonExcel);
  import invoiceDetail from "@/views/invoice/invoiceDetails.vue";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import documentsView from "@/views/common/documentsView.vue";
  export default {
    provide() {
      return {
        parentValidator: this.$validator,
      };
    },
    watch: {

    },
    data: function () {
      return {
        markCompleteModal:false,
        clearedFromComputed:false,
        callFromList:false,
        filterApplyed:false,
        bulkCreateLoader:false,
        assigneeList:[],
        selected_users:[],
        cancelTokenSource: null,
        newFee:{
          'invoice':false,
          'amount':null,
          'name':"",
          'type':'other',
          'id':0
        },
        selectedFileForEdit:false,
        loadingLabel:false,
        showUploadDocs:false,
        resetConfiramtionPopup:false,
        documents:[],
        selectedPetition:null,
        selectedIndex:null,
        noDataText:'Choose Case Type & Sub Type for <br/> Pending Invoices',
        petitionTypes:[],
        petitionSubTypes:[],
        selectedPetitionType:null,
        selectedPetitionSubType:[],
        selectedFillingFee:[],
        fillingFeeList:[],
        selectedInvoicesIds:[],
        selectAllInvoices:false,
        pendingInvoiceList:[],
        masterPendingInvoiceList:[],
        selectedForInvoicesList : [],
        selectedInvoiceItems:[],
        invoiceRespose:null,
        settings: { // perfectscrollbar settings
          // maxScrollbarLength: 60,
          // wheelSpeed: .60,
        },
        formSubmited: false,

        expandModal: false,
        docPrivew: false,
        showCloseIcon:false,
        showConfrmLetterPopup:false,
        docValue: "",
        docType: "",
        selectedFile: null,
        invoiceDetails:null,
        selectedFeeItem:null,
        updatedInitStatus: [
        { _id: "637f7c565648c5150123dall", id: 9, "name": "All", "sortName": "All" },
        { _id: "637f7c565648c5150123deab", id: 1, name: "Active", sortName: "active" },
        { _id: "637f7c565648c5150123dfiled", id: 10, "name": "Filed", "sortName": "Filed" },
        { _id: "637f7c565648c5150123deac", id: 2, name: "On Hold", sortName: "on hold" },
        { _id: "637f7c565648c5150123dead", id: 3, name: "Abandoned", sortName: "abandoned" },
        { _id: "637f7c565648c5150123deae", id: 4, name: "Deleted", sortName: "deleted" }
      ],
      getFiledCasesFiltered: false,
      initStatusIdsFilter:null,
        archiving: false,
        internalErrMsg: '',
        docValue:[],
        uploading: false,
        permDeleteDocs: [],
        editor: ClassicEditor,
        internalComments: '',
        internalStatusDetails: null,
        selectedAllForArchive: false,
        selectedForArchiveList : [],
        checkHeaderCheckBox: { "_id": "637f076578adb65c4c208e2d", "id": 1, "name": "Active", "sortName": "active" },
        editorConfig: {
        toolbar: ['bold', 'italic', '|', 'undo', 'redo', 'NumberedList', 'BulletedList',],
      },
        showCapRegistrations:false,
        debounce:null,
        canRegCap:null,
        showCapErrorCreatioInfo:false,
        isSlg: true,
        capCreationErrors: '',
        newCapFormSubmited: false,
        withAccount: 'true',
        newBeneficiary: [
          {
            firstName: '',
            middleName: '',
            lastName: '',
            name: "",
            email: "",
            phone: "",
            phoneCountryCode: { countryCode: '', countryCallingCode: '' }
          },
        ],
        bulkBeneficiary: false,
        jsonData: [
          { "name": "SR", "email": 'ravis@innvectra.com' },
          { "name": "Ravi Kumar", "email": 'ravi@innvectra.com' }
        ],
        formerrors: {
          msg: ''
        },
        headerSelectedCaseTypes: [],
        selectedSeasons: [],
        selectedpremiumProcessing: [],
        premiumProcessingList: [{ name: 'Yes', _id: true }, { name: 'No', _id: false }],
        selectedStatus: [],
        caseStatusList: [],
        selectedEducations: [],
        education_types: [],
        selectedtypeNames: [],
        headerTypeNames: [],
        autoApply: '',
        disableOffice: false,
        branchList: [],
        selectedBranch: null,
        premiumProcessing: false,
        petitionersList: [],
        selectedPetitioners:[],
        beneficiaryMasterDataList: [],
        selectedPetitioner: null,
        selectedBeneficiary: null,
        selectedUsername: null,
        selectedUser: null,
        invoiceList: [],
       
        sortKeys: {},
        sortKey: {},
        page: 1,
        perpage: 25,
        totalpages: 0,
        totalCount:0,
        perPeges: [10, 25, 50, 75, 100, 500],
        callFromSearch: false,
        isListloading: false,
        filter_searchtxt: '',
        searchtxt: '',
        header_selected_petitioners: [],
        selected_peritioners: [],
        final_selected_peritioners: [],
        encodedString: '',
        selected_createdDateRange: ["", ""],
        /////
        enableNextBtn: false,
        selectAllForArchive: false,
        selectedItem: false,
        value: null,
        values: null,
        capvalues: null,
        Petitioner: null,
  
        selected: null,
        selecte: null,
        AddBeneficiary: false,
        addPetitionerr: false,
        addcprbeneficiary: false,
        NewPetition: false,
        anonymousUser: false,
        options: ['10th / 12th Grade', 'Bachelors', 'Associate', 'Masters'],
        optionscase: ['Active', 'In active'],
        cap: [{ "name": 'Master Cap', "id": true, },
        { "name": 'Regular Cap', "id": false, }],
        Petitioneroptions: ['James', 'Michael'],
        caps: ['Master Cap', 'Regular Cap'],
        Petitioners: ['James', 'Michael'],
        season: [],
        fromUserList: ['Created', 'Sent for Petitioner Authorization', 'Petitioner Confirmation', 'Attorney Approval', 'Receipt of Payment Made', 'Submitted to USCIS', 'Selected', 'Petition Created'],
        //beneficiaryMasterDataList:['Rahul krishna' , 'Sathish'],
        PetitionerMasterDataList: ['Rahul krishna', 'Sathish'],
  
        selected_deadLineDateRange: ["", ""],
        wiseSelection: 'true',
        activeCases: true,
        getFiledCases: false,
        selectedVisaType: null,
        visaTypes: [],
        selected_subtypes: [],
        all_subtypes: [],
        selected_statusids: [],
        case_statusids: [],
        final_selected_statusids: [],
        paymentStatus:[
    {
        "id":1,
        "name":"Created"
    },
    {
        "id":2,
        "name":"Sent"
    },
    // {
    //     "id":3,
    //     "name":"Delivery Error"
    // },
    // {
    //     "id":4,
    //     "name":"Viewed"
    // },
    {
        "id":5,
        "name":"Partially Paid"
    },
    {
        "id":6,
        "name":"Fully Paid"
    },
    // {
    //     "id":7,
    //     "name":"Deposited"
    // },
    // {
    //     "id":8,
    //     "name":"Pending"
    // }
],
        selected_paymentstatusids:[],
        final_selected_paymentstatusids:[],
        petition:null
  
      }
    },
    components: {
      markAsCompleteInvoice,
      documentsView,
      invoiceDetail,
      XIcon,
      MoreVerticalIcon,
      immiPhone,
      immiInput,
      //bulkBeneficiary,
      Multiselect,
      VuePerfectScrollbar,
      Paginate,
      NoDataFound,
      addBeneficiary,
      addBenewPet,
      //addBeneficiary,
      //addPetitioner,
      Datepicker,
      DateRangePicker,
      FileUpload,
  
    },
    methods: {
      hideMe(){
        this.invoiceRespose = null;
        this.markCompleteModal = false;
        this.getPendingInvoiceList();
      },
      getUsersList(searchText = '', callFromSearch = false){
        let payload = {
          "matcher": {
            "roleIds": [6],
            "title": searchText,
            "searchString":searchText,
            "statusIds": [],
            "stateIds": [],
            "locationIds": [],
            "createdDateRange": [],
          },
          "listForFilters":true,
          
          "sorting": {
              "path": "createdOn",
              "order": -1
          },
          "page": 1,
          "perpage": 1000,
        };
        if(callFromSearch){
          this.assigneeList = [];
        }
        this.$store.dispatch("getList", { data: payload, path: '/users/list' }).then(response => {
          if(response && response.list){
            this.assigneeList = response.list
          }else{
            this.assigneeList = [];
          }
        }).catch((err)=>{})
      },
      hideConfirmation(action = false){
        let self = this;
        this.resetConfiramtionPopup = false;
        let list = this.pendingInvoiceList;
        let masterData = this.masterPendingInvoiceList;
        if(action){
          setTimeout(()=>{
            this.resetInvoices();
          })
        }
      },
      checkSelectedVal(val, index){
        let selectedVal = val;
        let selectIndex = index;
        if(!this.getSelectedObj({'obj':selectedVal})){
          this.pendingInvoiceList[selectIndex]['isInvoiceSelected'] = false;
          this.selectedForInvoicesList = _.filter(this.selectedForInvoicesList, (item) => {
            return item != selectedVal['_id']
          })
          this.selectedInvoiceItems = _.filter(this.selectedInvoiceItems, (item) => {
            return item != selectedVal
          })
          this.updateList();
        }
      },
      createFees(action = false){
        if(action){
          this.$validator.validateAll('newLabelform').then(result => {
            if(result){
              if(this.newFee && this.checkProperty(this.newFee, 'amount')){
                this.newFee['amount'] = parseInt(this.newFee['amount'])
              }
              this.pendingInvoiceList[this.selectedIndex]['feeDetails'].push(this.newFee);
              this.newFee = {
                'invoice':false,
                'amount':null,
                'name':"",
                'type':'other',
                'id':0,
                isSelected:true
              },
              this.$modal.hide('createFilingFeeModal')
            }
          })
        }else{
          this.newFee = {
            'invoice':false,
            'amount':null,
            'name':"",
            'type':'other',
            'id':0,
            isSelected:true
          },
          this.$modal.hide('createFilingFeeModal')
        }
      },
      openFilingFeePopup(val, Index){
        this.selectedPetition=null
        this.documents = [];
        if(val){
          this.selectedPetition = val;
          this.selectedIndex = Index;
          let objIds = _.map(this.selectedPetition['feeDetails'], 'id')
          let maxId = objIds.length > 0 ? _.max(objIds) : 0;
          let time = new Date().getTime()
          this.newFee = {
            'invoice':false,
            'amount':null,
            'name':"",
            'type':'other',
            'id':time,
            isSelected:true
          },
          this.$modal.show('createFilingFeeModal')
        }
      },
      searchCases(){
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.page=1
        this.getPendingInvoiceList();
      }, 900)
      
    },
      removeFiles(index){
        let item=this.documents[index]
      this.documents.splice(index ,1)
      this.removeFileFromS3(item)
        
        // let item = this.selectedPetition['filingFeeDocs']['cheques'][index]
        // this.selectedPetition['filingFeeDocs']['cheques'].splice(index ,1)
        // this.removeFileFromS3(item)
      },
      uploadDocuments(val, index){
        this.selectedPetition=null
        this.documents = [];
        if(val){
          this.selectedPetition = val;
          this.selectedIndex = index.toString();
          if(this.checkProperty(this.selectedPetition, 'filingFeeDocs', 'cheques')){
            this.showUploadDocs = true;
          }
        }
      },
      hideUploadDocs(action=false){
        if(action){
          this.documents = [];
          this.pendingInvoiceList[this.selectedIndex]['filingFeeDocs']['cheques'] = [];
          this.showUploadDocs = false;
        }else{
          if(this.documents && this.documents.length>0 && this.selectedIndex){
            this.pendingInvoiceList[this.selectedIndex]['filingFeeDocs']['cheques'] = this.documents;
            this.selectedPetition = null;
            this.selectedIndex = null;
            this.documents = [];
          }else{
            this.selectedPetition = null;
            this.selectedIndex = null;
            this.documents = [];
          }
          this.showUploadDocs = false;
        }
        
        
      },
      updateData(docs, category){
        this.documents = docs
      },
      getVisaTypes() {
        this.page=1
        let item = {
          matcher: {
            "searchString": '',
          },
          page: this.page,
          perpage: this.perpage,
          category: "petition_types",
          "sorting": {
            "path": "name",
            "order": 1
          }
        };

        this.$store
          .dispatch("getMasterData", item)
          .then(response => {
            this.petitionTypes = [];
            this.petitionTypes = response.list;
          });
      },
      changedPetitionVisaType(){
        this.searchtxt = '';
        this.page=1
        this.petitionSubTypes = [];
        this.selectedPetitionSubType = [];
        this.getPetitionSubTypes();
      },
      getPetitionSubTypes(){
        this.searchtxt = '';
        this.page=1
        if (this.selectedPetitionType && _.has(this.selectedPetitionType, "id")) {
          let item = {
            matcher: {
              getAllSubTypes: false,
              searchString: '',
              petitionType: parseInt(this.selectedPetitionType['id']),
            },
            page: 1,
            perpage: 1000,
            category: "petition_sub_types",
            "sorting": {
              "path": "name",
              "order": 1
            }
          };
          this.$store.dispatch("getMasterData", item).then((response) => {
            this.petitionSubTypes = response.list;
          });
        }
      },
      changedPetitionSubType(){
        this.searchtxt = '';
        this.page=1
        this.getPendingInvoiceList();
        if(this.selectedPetitionSubType){
          this.getFilingFeeList();
        }else{
          this.fillingFeeList = [];
        }
        
      },
      getFilingFeeList(){
        let payLoad={
          type:this.checkProperty(this.selectedPetitionType, 'id'),
          subType:this.checkProperty(this.selectedPetitionSubType, 'id')
        }
        this.selectedFillingFee = [];
        this.fillingFeeList = [];
        let path = '/invoices/get-case-type-subType-filing-fee-categories';
        this.$store.dispatch("commonAction", { "data": payLoad, "path": path }).then((response) => {
          if(response && response['invoiceDetails'] ){
            this.fillingFeeList = response['invoiceDetails']
          }
        }).catch((err)=>{

        })
      },
      updateInvoices(val){
        if(this.checkProperty(this.selectedFillingFee, 'length')>0 && this.checkProperty(this.pendingInvoiceList, 'length')>0){
          let selectedItem = []
          _.forEach(this.selectedFillingFee, (item)=>{
            if(item['_id']){
              _.forEach(this.pendingInvoiceList, (lItem)=>{
                if(this.checkProperty(lItem, 'feeDetails', 'length')>0){
                  _.forEach(lItem['feeDetails'], (obj)=>{
                    if(item['_id'] == obj['_id']){
                      selectedItem.push(item['_id'])
                      obj['isSelected'] = true; 
                      obj['isSelectedGlobal'] = true; 
                    }
                    else{
                      if(obj['isSelectedGlobal'] && obj['isSelected'] && selectedItem.indexOf(obj['_id'])<=-1 ){
                        obj['isSelected'] = false; 
                        obj['isSelectedGlobal'] = false; 
                      }
                    }
                  })
                }
              })
            }
          })
          this.pendingInvoiceList = _.cloneDeep(this.pendingInvoiceList);
        }else if(this.checkProperty(this.pendingInvoiceList, 'length')>0 && this.checkProperty(this.selectedFillingFee, 'length')<=0){
          _.forEach(this.pendingInvoiceList, (lItem)=>{
            if(this.checkProperty(lItem, 'feeDetails', 'length')>0){
              _.forEach(lItem['feeDetails'], (obj)=>{
                if(obj['isSelectedGlobal'] && obj['isSelected'] ){
                  obj['isSelected'] = false; 
                  obj['isSelectedGlobal'] = false; 
                }
              })
            }
          })
          this.pendingInvoiceList = _.cloneDeep(this.pendingInvoiceList);
        }
      },
      resetInvoices(){
        this.getPendingInvoiceList();
      },
      generateBulkInvoices(){
        let payLoad={
          items:[]
        }
        if(this.selectedInvoiceItems && this.selectedInvoiceItems.length>0){
          // let filteredArr = this.selectedInvoiceItems.map(item => ({...item,
          //   feeDetails: item.feeDetails.filter(detail => detail.isSelected)
          // }));
          // let filteredArr = this.selectedInvoiceItems.map(item => ({...item, invoices: item.feeDetails}));
          let filteredArr = [];
          let obj = {
            category:'invoices',
            invoices:[],
          }
          _.forEach(this.selectedInvoiceItems, (itm)=>{
            obj['invoices'].push(itm);
          })
          filteredArr.push(obj);
            obj = {
              category:'invoices',
              invoices:[],
            }

          payLoad['items'] = filteredArr;
        }
     this.bulkCreateLoader = true;
     this.invoiceRespose = null;
        let path = 'invoices/create-bulk-invoice-request';
        this.$store.dispatch("commonAction", { "data": payLoad, "path": path }).then((response) => {
          this.showToster({ message: response.message, isError: false });
          this.invoiceRespose = response
          this.bulkCreateLoader = false;
          // this.getPendingInvoiceList();
          if(response && this.checkProperty(response, 'items') && this.checkProperty(response, 'items', 'success') && this.checkProperty(response['items'], 'success', 'length')>0){ 
            this.markCompleteModal = true;
          }else{
            this.getPendingInvoiceList();
          }
          
          
        }).catch((err)=>{
          this.bulkCreateLoader = false;
          this.showToster({ message: err, isError: true });
          this.getPendingInvoiceList();
        })
      },
      selectAllforInvoices(){
        this.selectedForInvoicesList = [];
        this.selectedInvoicesIds = [];
        this.selectedInvoiceItems = [];
        _.forEach(this.pendingInvoiceList, (item) => {
          item.isInvoiceSelected = false;
          if (this.selectAllInvoices ) {
            if(this.getSelectedObj({'obj':item})){
              item.isInvoiceSelected = true;
              this.selectedForInvoicesList.push(item._id)
              this.selectedInvoiceItems.push(item);
              if (!this.selectedInvoicesIds.includes(item['statusId'])) {
                this.selectedInvoicesIds.push(item['statusId']);
                
              }
            }
          }
        })
      },
      selectForInvoice(caseItem) {
        this.formerrors.msg = '';
        if (this.checkProperty(caseItem, 'isInvoiceSelected') ) {
            if (this.selectedForInvoicesList.indexOf(caseItem['_id']) <= -1) {
              this.selectedForInvoicesList.push(caseItem['_id'])
              if (!this.selectedInvoiceItems.includes(caseItem)) {
                this.selectedInvoiceItems.push(caseItem);
              }
            }

        } else {
          this.selectedForInvoicesList = _.filter(this.selectedForInvoicesList, (item) => {
            return item != caseItem['_id']
          })
          this.selectedInvoiceItems = _.filter(this.selectedInvoiceItems, (item) => {
            return item != caseItem
          })
        }
        this.selectAllInvoices = false;
        if (this.selectedForInvoicesList.length > 0 && (this.pendingInvoiceList.length == this.selectedForInvoicesList.length)) {
          this.selectAllInvoices = true;
        }
      },
      scroll(){},
      updateList(){
        this.pendingInvoiceList = _.cloneDeep(this.pendingInvoiceList)
      },

      download_or_view(docItem) {
      let value = _.cloneDeep(docItem);
      this.showCloseIcon = false;
      this.expandModal= false;



      var _self = this;
      this.formSubmited = false;
      if (_.has(value, "path")) {
        value["url"] = value["path"];
        value["document"] = value["path"];
      }

      if (_.has(value, "url")) {
        value["path"] = value["url"];
        value["document"] = value["url"];
      }

      if (_.has(value, "document")) {
        value["path"] = value["document"];
        value["url"] = value["document"];
      }

      this.selectedFile = value;
      this.docValue = "";
      this.docPrivew = false;
      this.docType = false;
      this.docType = this.findmsDoctype(value);
      this.showCloseIcon = false;

      //if ( (this.docType == "office" || this.docType == "image" || this.docType == "pdf") && value.download == false ) {
      if (this.docType == "office" || this.docType == "image" || this.docType == "pdf") {
        value.url = value.url.replace(this.$globalgonfig._S3URL, "");
        value.url = value.url.replace(this.$globalgonfig._S3URLAWS, "");
        let postdata = {
          keyName: value.url,
          petitionId: value["petitionId"],
        };
        this.$store.dispatch("getSignedUrl", postdata).then((response) => {
          this.docValue = response.data.result.data;

          if (this.docType == "office") {
            document.getElementById("placeholder").innerHTML =
              "  <div  id='placeholder2' style='height:100%'></div>";
            let _editing = false;

            if ([50, 51].indexOf(this.getUserRoleId) > -1) {
              _editing = false;
            }
           
            let docViewUrl ='https://immibox.com/api/petition/post-edited-document';
            if(_.has(this.$globalgonfig, 'DOC_VIEW_URL')){
              docViewUrl = this.$globalgonfig['DOC_VIEW_URL'];
            }

            let entityId = 'cover_letter';
            if(this.checkProperty(value,'entityId')){
              entityId = value['entityId'];
            }
               
            if ( _.has(value ,'viewmode') && value.viewmode==false ) {
              _editing = true;
              if(_.has(value,'type') && _self.checkProperty(value, 'type') == 'Letter' && _.has(value,'generated') &&
              (_self.checkProperty(value, 'generated') == true || _self.checkProperty(value, 'generated') == 'true') && !value['parentId'] 
               ){
                //&& !value['parentId'] removed parentId in above condition as per requirement
                this.showCloseIcon = true; 
                // && this.checkProperty( this.$store.state ,'selectedForEditDocument') && this.checkProperty( this.$store.state ,'selectedForEditDocument', 'savedDocumentId')
              } 
            }
            var _ob = {};
            if (value.editedDocument) {
              _ob = {
               // entityId:entityId,
                petitionId: this.petition._id,
                name: value.name,
                _id: value._id,
                extn: "docx",
                formLetterType: "Letter",
                parentId: value.parentId,
              };
            } else {
              _ob = {
               // entityId:entityId,
                name: value.name,
                petitionId: this.petition._id,
                _id: value._id,
                extn: "docx",
                formLetterType: "Letter",
                parentId: value._id,
              };
            }
            var nid = value._id +  Math.round(+new Date()/1000)
            window.docEditor = new DocsAPI.DocEditor("placeholder2", {
              document: {
                c: "forcesave",
                fileType: "docx",
                key: nid,
                userdata: JSON.stringify(_ob),
                title: value.name,
                url: response.data.result.data,
                permissions: {
                  edit: _editing,
                  download: true,
                  reader: false,
                  review: false,
                  comment: false,
                },
              },

              documentType: "word",
              height: "100%",
              width: "100%",

              editorConfig: {
                userdata: JSON.stringify(_ob),
                callbackUrl:
                docViewUrl+"?entityId="+entityId+"&payload=" +
                  JSON.stringify(_ob) +
                  "&token=" +
                  _self.$store.state.token +
                  "&name=" +
                  value.name.replace(".docx", ""),
                customization: {
                  logo: {
                    image: "https://immibox.com/app/favicon.png",
                    imageDark: "https://immibox.com/app/favicon.png",
                    url: "https://immibox.com",
                  },
                  anonymous: {
                    request: false,
                    label: "Guest",
                  },
                  chat: false,
                  comments: false,
                  compactHeader: false,
                  compactToolbar: true,
                  compatibleFeatures: false,
                  feedback: {
                    visible: false,
                  },
                  forcesave: true,
                  help: false,
                  hideNotes: true,
                  hideRightMenu: true,
                  hideRulers: true,
                  layout: {
                    toolbar: {
                      collaboration: false,
                    },
                  },
                  macros: false,
                  macrosMode: "warn",
                  mentionShare: false,
                  plugins: false,
                  spellcheck: false,
                  toolbarHideFileName: true,
                  toolbarNoTabs: true,
                  uiTheme: "theme-light",
                  unit: "cm",
                  zoom: 100,
                },
              },
              events: {
                onReady: function () {},
                onDocumentStateChange: function (event) {
                  var url = event.data;
                  if (!event.data) {
                    if (value.editedDocument) {
                    }
                  }
                },
              },
            });
            //this.docValue = encodeURIComponent(response.data.result.data);
          }

          if (this.docType == "pdf") {
            var formAndLetterId = value._id;
            let parentId = '';
            // if (this.checkProperty(value,'parentId')) {
            //   parentId = value.parentId;
            // }
            //else{
            //   if (this.checkProperty(value,'generated')) {
            //     parentId = value._id;
            //   }
             
            // }
            //alert(parentId)
            var  viewmode = 0; //viewmode= 1 Enable edit AND viewmode= 0; //Disabled Edit
            let pdfViewUrl ='https://immibox.com/viewer/pdfjs-dist/web/viewerv2.html';
            
            if(_.has(this.$globalgonfig, 'PDF_VIEW_URL')){
              pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL'];
            }
             

            if(_.has(value ,'viewmode')){
              if (value.viewmode) {
                viewmode = 0;
              }else{
                viewmode = 1;
                viewmode=viewmode+"&depLabel="+value.depLabel+"&depType="+value.depType+"&docUserType="+value.docUserType+"&generated="+value.generated+"&parentId="+parentId+"&formAndLetterId="+formAndLetterId+"&save=v2&docname="+value.name+"&posturl="+this.$globalgonfig._APIURL+"/&petitionId="+this.$route.params.itemId+"&entityId="+value.entityId+"&token="+this.$store.state.token
                if(_.has(this.$globalgonfig, 'PDF_EDIT_URL')){
                  pdfViewUrl = this.$globalgonfig['PDF_EDIT_URL'];
                  
                 }
              }

            }

           
            
           
            if(this.getPetitionTab != 'Forms and Letters'){
              viewmode= 0; //Disabled Edit
              if(_.has(this.$globalgonfig, 'PDF_VIEW_URL')){
                pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL'];
              }
              
            }
           
            this.docValue =
            pdfViewUrl+"?view=" +
              viewmode +
              "+&file=" +
              encodeURIComponent(response.data.result.data);
          }
          this.docPrivew = true;
        });
      } else {
        this.downloads3file(value);
      }
    },
        formatprice(amount) {
      return formatter.format(amount);
    },




        showDetails(item){
          let routedId = this.checkProperty(item, 'petitionId');
          if(this.checkProperty(item, 'subType') == 15){
            this.$router.push({ path: `/gc-employment-details/${routedId}`})
          }else{
            this.$router.push({ path: `/petition-details/${routedId}`})
          }
        },
 
      getPendingInvoiceList(callFromSearch = false, callFromFilter = false) {
        if (this.cancelTokenSource) {
          this.cancelTokenSource.abort()
        }
      this.selectAllInvoices = false;
      this.callFromSearch = true;
      if (this.callFromSearch) {
        this.invoiceList = []
      }
      let tempObj={
        page: this.page,
        perpage: this.perpage,
        sortKey: this.sortKey,
      };

      let Payload={
        "matcher": {
          "rfeCases": true,
          "searchString": this.searchtxt,
          "petitionerIds": [],
          "typeIds": [],
          "createdDateRange":[],
          "attorneyIds":[],
          "subTypeIds": []
        },
        "page": this.page,
        "perpage": this.perpage,
        "sorting": this.sortKey,
      }; 

      if(this.checkProperty(this.selectedPetitionType, 'id')){
        Payload['matcher']['typeIds'].push(this.checkProperty(this.selectedPetitionType, 'id'))
      }
      if(this.checkProperty(this.selectedPetitionSubType, 'length')>0){
        Payload['matcher']['subTypeIds'] = this.selectedPetitionSubType.map((item) => item.id)
      } 
      if(this.checkProperty(this.selectedPetitioners, 'length')>0){
        Payload['matcher']['petitionerIds'] = this.selectedPetitioners.map((item) => item.userId)
      } 
      if(this.checkProperty(this.selected_users, 'length')>0){
        Payload['matcher']['attorneyIds'] = this.selected_users.map((item) => item._id)
      } 
      if (this.selected_createdDateRange["startDate"] && this.selected_createdDateRange["startDate"] != "" && 
      this.selected_createdDateRange["endDate"] != "" && this.selected_createdDateRange["endDate"]) {
        Payload["matcher"]["createdDateRange"] = [this.selected_createdDateRange["startDate"],this.selected_createdDateRange["endDate"]];
      }
      this.selectedForInvoicesList = [];
      this.selectedInvoicesIds = [];
      this.selectedInvoiceItems = [];
      this.pendingInvoiceList = []
      this.masterPendingInvoiceList = [];
      this.bulkCreateLoader = false;
      this.isListloading = true;
      this.updateLoading(true, 'NoDataFoundRefff');
      this.cancelTokenSource = new AbortController();  //commonAction pending  /invoices/generate-invoice-list
      const signal = this.cancelTokenSource.signal;
      this.filterApplyed = true;
      this.callFromList = true;
      this.clearedFromComputed = false
      this.$store.dispatch("commonActionWithAbort", { "data": Payload, "path": "/invoices/generate-invoice-list", cancelTokenSource: signal }).then((response) => {
        this.filterApplyed = false;
        let list = response.list
        if(this.checkProperty(list, 'length')>0){
          _.forEach(list, (lItem)=>{
            lItem['isInvoiceSelected'] = false;
            if(this.checkProperty(lItem, 'feeDetails', 'length')>0){
              _.forEach(lItem['feeDetails'], (obj)=>{
                if(!_.has(obj, 'isSelected') || !obj['isSelected'] ){
                  obj['isSelected'] = false; 
                  obj['isSelectedGlobal'] = false; 
                  obj['isAlreadyExist'] = false;
                  obj['isOffline'] = true; 
                }else{
                  obj['isAlreadyExist'] = true;
                  obj['isOffline'] = true;  
                }
              })
            }
          })
          this.pendingInvoiceList = _.cloneDeep(list);
          this.masterPendingInvoiceList = _.cloneDeep(list);
        }
        this.isListloading = false;
        this.updateLoading(false, 'NoDataFoundRefff');
        this.totalCount = this.checkProperty(response, 'totalCount')
        this.totalpages = Math.ceil(response.totalCount / this.perpage)
        setTimeout(() => {
          this.updateLoading(false, 'NoDataFoundRefff');
        }, 10);
      })
      .catch((err) => {
        this.filterApplyed = false;
        this.isListloading = false;
        this.updateLoading(false, 'NoDataFoundRefff');
      })
    },
      remove(item, data, filindex) {
        data.splice(filindex, 1);
        //this.disablePWDstatus = false;
        this.removeFileFromS3(item)
      },


      pageNate(pageNum) {
  
        this.page = pageNum;
        this.getPendingInvoiceList();
      },

      peritioners_search_fun(searchText) {
        clearTimeout(this.debounce)
          this.debounce = setTimeout(() => {
            this.getPetitioners(true, searchText);
          }, 900)
      },
      usersAttorneySearch(searchText) {
        clearTimeout(this.debounce)
          this.debounce = setTimeout(() => {
            this.getUsersList(searchText, true);
          }, 900)
      },
      changeperPage() {
        this.page = 1;
        localStorage.setItem('petitions_perpage', this.perpage);
        this.getPendingInvoiceList(true);
      },
      sortMe(sort_key = '') {
        if (sort_key != '') {
          this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1
          this.sortKey = {};
          this.sortKey = { "path": sort_key, "order": this.sortKeys[sort_key] }
          localStorage.setItem('petitions_sort_key', sort_key);
          localStorage.setItem('petitions_sort_value', this.sortKey[sort_key]);
          this.getPendingInvoiceList();
        }
      },
      set_filter: function (callFromMounted = false) {
        this.getPendingInvoiceList();
      },
      getPetitioners(callFromSerch = false, searchText = '') {
  
        let _self = this;
        let query = {
          "matcher": {
            "searchString": searchText,
            "statusIds": [],
            "countryIds": [],
            "stateIds": [],
            "locationIds": [],
            "createdDateRange": []
          },
          "sorting": { "path": "createdOn", "order": 1 },
          "page": 1,
          "perpage": 100,
          getMasterData: true
        }
  
  
        this.$store.dispatch("getList", { data: query, path: '/company/list' }).then(response => {
  
          _self.petitionersList = response.list;
  
        }).catch((err) => {
          this.petitionersList = [];
  
        })
      },
      clearDateRangePicker(){
        this.selected_createdDateRange = {};
        this.updateLoader()
      },
      updateLoader(){
        setTimeout(() => {
          this.updateLoading(false, 'NoDataFoundRefff');
        });
      },
    },
    mounted() {
      this.updateLoading(false, 'NoDataFoundRefff');
      this.getUsersList()
      this.getVisaTypes();
      // this.getPendingInvoiceList();
      if (this.checkProperty(this.getUserData, 'tenantDetails') && this.checkProperty(this.getUserData, 'tenantDetails', 'slug') != 'slg') {
        this.isSlg = false;
      }
     
      this.sortKeys = {
        beneficiaryName:1,
        beneficiaryCustomId:1,
        issuedToDetails:1,
        petitionType:1,
        invoiceRaiseDate:1
  
      },
        this.sortKey = { "path": 'updatedOn', "order": -1 };
      //caseStatusList
      this.getPetitioners();
      this.initStatusIdsFilter = { "_id": "637f076578adb65c4c208e2d", "id": 1, "name": "Active", "sortName": "active" };
  

    },
    computed: {
      checkCreatedVal(){
        let returnVal = false;
        if (this.selected_createdDateRange["startDate"] && this.selected_createdDateRange["startDate"] != "" && 
        this.selected_createdDateRange["endDate"] != "" && this.selected_createdDateRange["endDate"]) {
          returnVal = true;
        }
        return returnVal
      },
      checkFilterAppliedval(){ 
        let returnVal = false;
        if(this.searchtxt){
          returnVal = true;
          return returnVal
        }
        if(this.checkProperty(this.selectedPetitionType, 'id')){
          returnVal = true;
          return returnVal
        }
        if(this.checkProperty(this.selectedPetitionSubType, 'length')>0){
          returnVal = true;
          return returnVal
        } 
        if(this.checkProperty(this.selectedPetitioners, 'length')>0){
          returnVal = true;
          return returnVal
        } 
        if(this.checkProperty(this.selected_users, 'length')>0){
          returnVal = true;
          return returnVal 
        } 
        if (this.selected_createdDateRange["startDate"] && this.selected_createdDateRange["startDate"] != "" && 
        this.selected_createdDateRange["endDate"] != "" && this.selected_createdDateRange["endDate"]) {
          returnVal = true;
          return returnVal
        }
        if(returnVal == false){
          this.pendingInvoiceList = [];
          this.clearedFromComputed = true
        }
        return returnVal
      },
      getSelectedObj(){
        return (data)=>{
          let returnVal = false;
          let list = [];
          let petition = data['obj'];
          if(this.checkProperty(petition,'feeDetails') && this.checkProperty(petition,'feeDetails','length')>0 ){
            _.forEach(petition['feeDetails'], (item)=>{
              if(item && item['isSelected'] && !item['isAlreadyExist']){
                list.push(item)
              }
            })
          }
          if(list&& list.length>0){
            returnVal = true
          }
          return returnVal
      }
        

      },
      enableSelectedAll(){
        let returnVal = false;
        let list = [];
        if(this.checkProperty(this.pendingInvoiceList, 'length')>0){
          _.forEach(this.pendingInvoiceList, (mItem)=>{
            if(this.checkProperty(mItem,'feeDetails') && this.checkProperty(mItem,'feeDetails','length')>0 ){
              _.forEach(mItem['feeDetails'], (item)=>{
                if(item && item['isSelected'] && !item['isAlreadyExist']){
                  list.push(item)
                }
              })
            }
          })
        }
        if(list && list.length>0){
          returnVal = true
        }
        if(returnVal == false){
          this.selectAllInvoices = false
        }
        return returnVal
      },
      getselectedForInvoicesList(){
        let returnVal = false;
        if(this.checkProperty(this.selectedForInvoicesList, 'length')>0){
          returnVal = true;
        }
        return returnVal
      }
      
    },
   
  };
  </script>